import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import { WOW } from 'wowjs';
import '../css/global.css';
import '../css/Milestone.css';

const timelineData = [
    { year: "1974", text: "Colombo Dockyard incorporated with an initial facility of three dry docks" },
    { year: "1975", text: "Shipbuilding begins in Sri Lanka and first patrol boat made for SL Navy", image: "/wp-content/themes/cdl/images/history/1975.jpg" },
    { year: "1976", text: "Ceylon Shipping Agency incorporated in collaboration with Ceylon Shipping Corp" },
    { year: "1977", text: "The Colombo Port Commission gets its first vessel, a 100 Ton Barge" },
    { year: "1978", text: "First Towing Tug Boat built in Sri Lanka for the Colombo Port Commission" },
    { year: "1981", text: "Incorporation of Dockyard General Engineering Services" },
    { year: "1982", text: "First Offshore Patrol Vessel (OPV) built for Sri Lanka Navy", image: "/wp-content/themes/cdl/images/history/1982.jpg" },
    { year: "1983", text: "First export order in shipbuilding for Burma Ports Corporation, Myanmar", image: "/wp-content/themes/cdl/images/history/1983.jpg" },
    { year: "1987", text: "First Shipbuilding project for the Republic of Maldives", image: "/wp-content/themes/cdl/images/history/1987.jpg" },
    { year: "1988", text: "Colombo Drydocks Ltd begins operations at the newly built 125,000 DWT dry dock", image: "/wp-content/themes/cdl/images/history/1988.jpg" },
    { year: "1992", text: "Aluminium shipbuilding begins with Fast Patrol Boat production for SL Navy", image: "/wp-content/themes/cdl/images/history/1992.jpg" },
    { year: "1993", text: "Restructuring of CDL and CDD with the collaboration of Onomichi Dockyard, Japan", image: "/wp-content/themes/cdl/images/history/1993.jpg" },
    { year: "1997", text: "Diversification of business activities into heavy engineering", image: "/wp-content/themes/cdl/images/history/1997.jpg" },
    { year: "1998", text: "First aluminium coastal surveillance vessel built for the Republic of Maldives", image: "/wp-content/themes/cdl/images/history/1998.jpg" },
    { year: "1999", text: "ISO 9001 certification for Lloyds Register of Quality Assurance (LRQA)" },
    { year: "2002", text: "Quality Management System certification upgraded to ISO 9001: 2000" },
    { year: "2004", text: "Diversification into Offshore Engineering and first project for Indian Navy", image: "/wp-content/themes/cdl/images/history/2004.jpg" },
    { year: "2005", text: "Expansion of shipbuilding activities into the Middle Eastern market", image: "/wp-content/themes/cdl/images/history/2005.jpg" },
    { year: "2006", text: "The year witnessed the building of the largest Aluminium hull ship to be built in Sri Lanka to date, a 40 M Fisheries Protection Vessel for the Republic of Maldives", image: "/wp-content/themes/cdl/images/history/2006.jpg" },
    { year: "2007", text: "Greatship (India) Ltd gets first Anchor Handling Tug / Supply Vessel (AHTSV)", image: "/wp-content/themes/cdl/images/history/2007.jpg" },
    { year: "2008", text: "Colombo Dockyards sees many new structural and technological adaptations" },
    { year: "2009", text: "National recognition and strong performance during a global downturn", image: "/wp-content/themes/cdl/images/history/2009.jpg" },
    { year: "2010", text: "CDL in the ‘Forbes list’ of top 200 Asian firms with sales under a billion USD", images: ["/wp-content/themes/cdl/images/history/2010-up1.jpg", "/wp-content/themes/cdl/images/history/2010-up2.jpg"] },
    { year: "2011", text: "CDL order books at capacity for Multipurpose Platform Supply Vessels (MPSV)", image: "/wp-content/themes/cdl/images/history/MPSV.JPG" },
    { year: "2012", text: "Proud moment: Start of construction of 400 passenger cum cargo vessel to India", image: "/wp-content/themes/cdl/images/history/400 Passenger Vessel.jpg" },
    { year: "2013", text: "Two decades of valuable collaboration with Onomichi Dockyard Co. Ltd, Japan" },
    { year: "2014", text: "Celebrating forty years of shipbuilding and ship repairing experience" },
    { year: "2016", text: "ISO 14001:2015 and OHSAS 18001:2007 certification" },
    { 
        year: "2019", 
        sections: [
            { text: "Establishment of Afloat Repair Service Unit (RRARS)", image: "/wp-content/themes/cdl/images/history/2019-1.jpg" },
            { text: "Expanding service station to South Coast (Hambantota)", image: "/wp-content/themes/cdl/images/history/2019-2.jpg" },
            { text: "Delivery of Cable Laying Vessel to Japan", image: "/wp-content/themes/cdl/images/history/2019-3.jpg" }
        ]
    },
    { year: "2020", text: "Contracting to build Hybrid Eco Bulk Carriers to Norway", image: "/wp-content/themes/cdl/images/history/2020.jpg" },
    { year: "2021", text: "Establishment of office at Trincomalee Port" },
    { year: "2022", text: "Energy Management system certification ISO 50001: 2018" },
    { year: "2023", text: "Contracting to build Hybrid Eco Bulk Carriers to Norway", image: "/wp-content/themes/cdl/images/history/2023.jpg" },
    { year: "2024", text: "Celebrating 50 years of excellence", image: "/wp-content/themes/cdl/images/history/2024.png" }
];

const Milestone = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        const wow = new WOW({ live: false });
        wow.init();
    }, []);

    return (
        <div className="milestone-page">
            <Header />
            
            <section id="mileston-wrapper">
                <div id="cd-timeline" className="cd-container">
                    {timelineData.map((item, index) => (
                        <div className="cd-timeline-block" key={index}>
                            <div className="cd-timeline-img">
                                <img src="/wp-content/themes/cdl/images/ship-img.png" alt="Ship Icon" />
                            </div>

                            <div className="cd-timeline-content">
                                <h2>{item.year}</h2>
                                {item.sections ? (
                                    item.sections.map((sec, sIdx) => (
                                        <div key={sIdx} style={{ marginBottom: sIdx === item.sections.length - 1 ? 0 : '20px' }}>
                                            <p>{sec.text}</p>
                                            {sec.image && (
                                                <div className="history-image">
                                                    <img src={sec.image} alt={`${item.year} history`} />
                                                </div>
                                            )}
                                        </div>
                                    ))
                                ) : (
                                    <>
                                        <p>{item.text}</p>
                                        {item.image && (
                                            <div className="history-image">
                                                <img src={item.image} alt={`${item.year} history`} />
                                            </div>
                                        )}
                                        {item.images && item.images.map((img, iIdx) => (
                                            <div className="history-image" key={iIdx}>
                                                <img src={img} alt={`${item.year} history part ${iIdx + 1}`} />
                                            </div>
                                        ))}
                                    </>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <Footer />
            <BackToTop />
        </div>
    );
};

export default Milestone;
